<template>
  <div>
    <div class="row mt-4">
      <!--<div class="col-auto pointer pr-0" v-on:click="seeAllMinutes(studentService)"><i class="material-icons btn-link">info_outline</i></div>-->
      <div class="col-auto pl-1"><h4 class="mb-0">{{service.get("name")}} <i>({{studentService["period"] == "weekly" ? "Weekly": "Monthly"}})</i>:</h4></div>
      <div class="col" />
      <div class="col-auto"><h4 class="mb-0">{{sum(serviceMinutes, "minutes")}} / {{studentService["minutes"]}}</h4></div>
    </div>
    <div class="separatorLine"/>
    <p v-if="serviceMinutes == null || serviceMinutes.length == 0">{{ selectedStudent.get("name") }} does not have any service minutes recorded this time period.</p>
    <div v-else class="row mt-2" v-for="minutes in serviceMinutes" :key="minutes.id">
      <div class="col text-left">
        <p class="mb-0"><b>{{minutes.get("date").toUTCString().split(' ')[2]}} {{minutes.get("date").toUTCString().split(' ')[1]}}, {{minutes.get("date").toUTCString().split(' ')[3]}}</b> - <i>{{minutes.get("userName")}}</i> - {{minutes.get("services")}}</p>
      </div>
      <div class="col-auto">
        <h4 class="pointer d-inline-block btn-link mb-0" v-on:click="editMinutes(minutes)">
          {{minutes.get("minutes")}}
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Student: Object,
    Service: Object,
    Minutes: Array,
  },
  data() {
    return {
      serviceMinutes: this.Minutes,
      service: this.Service,
      selectedStudent: this.Student,
      studentService: {}
    };
  },
  watch: {
    Student: function() {
      this.selectedStudent = this.Student;
      this.setupStudentService()
    },
    Service: function() {
      this.service =  this.Service
    },
    Minutes: function() {
     this.serviceMinutes = this.Minutes
     this.setupStudentService()
    }
  },
  mounted() {
    this.setupStudentService()
  },
  methods: {
    sum(items, prop) {
      if (items == null) {
        console.log("items was null!")
        return 0;
      }
      var sum = items.reduce((acc, item) => acc + item.get(prop), 0);
      return sum;
    },
    setupStudentService() {
      this.studentService = this.selectedStudent.get("services").find(s => s["service"] == this.service.id)
      this.studentService["name"] = this.service.get("name")
      if(this.studentService["period"] == "weekly"){
        var date = new Date(), y = date.getFullYear(), m = date.getMonth(), d = date.getDay()
        var firstDay = date.getDate() - d
        var lastDay = firstDay + 6
        var firstDate = new Date(y, m, firstDay, 0, 0, 0, 0)
        var lastDate = new Date(y, m, lastDay, 23, 59,59) 
        this.serviceMinutes = this.serviceMinutes.filter(sm => sm.get("date") <= lastDate && sm.get("date") >= firstDate)
      }
    },
    editMinutes(minutes){
      this.$emit("edit-minutes", minutes)
    },
    seeAllMinutes(service){
      this.$emit("see-service-minutes", service)
    }
  }
};
</script>